import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Heading, HelmetWrapper, SkipNavContent } from 'sarsaparilla';
import { addAlert } from '../../actions/alerts';
import { CurrentUserProps } from '../../props/currentUser';
import { OrganizationProps } from '../../props/organization';
import { getCurrentUser } from '../../reducers/currentUser';

import styles from './DownloadPage.scss';

const propTypes = {
  currentUser: CurrentUserProps,
  organizations: PropTypes.arrayOf(OrganizationProps),
  addAlert: PropTypes.func.isRequired
};

export class DownloadPage extends PureComponent {
  render() {
    const jsonDownloadURL = `${process.env.RIDB_ROOT}/downloads/RIDBFullExport_V1_JSON.zip`;
    const csvDownloadURL = `${process.env.RIDB_ROOT}/downloads/RIDBFullExport_V1_CSV.zip`;

    return (
      <SkipNavContent>
        <HelmetWrapper title="RIDB Recreation Data" />
        <main role="main" id="developer-portal-download-page" className={styles['download-page']}>
          <div className="body-wrap">
            <div className="rec-nested-wrap">
              <div className={`body-section ${styles['body-section']}`}>
                <Heading headingLevel={1} className={styles['recreation-data-heading']}>RIDB Recreation Data</Heading>
                <p>
                  To download all the RIDB recreation area, facility, and site level data in CSV or JSON format,
                  please select the link below. <em>Updated Daily.</em>
                </p>
                <ul>
                  <li><a href={csvDownloadURL} aria-label="RIDB Recreation Data CSV Format"> CSV Format </a></li>
                  <li><a href={jsonDownloadURL} aria-label="RIDB Recreation Data JSON Format"> JSON Format </a></li>
                </ul>
              </div>
              <div className={`body-section ${styles['body-section']}`}>
                <Heading headingLevel={1} className={styles['recreation-data-heading']}>RIDB/Recreation.gov Historical Reservation Data</Heading>
                <p>
                  Historical Reservation data is available for download from fiscal year 2006 to 2017.
                  As of October 12th, 2018 future Historical Reservation data will be available in a new format.
                  Please select the year to download a compressed CSV file.
                </p>
                <p>
                  <em>Updated April 2019.</em>
                </p>
                <ul>
                  <li>
                    <a
                      href={`${process.env.RIDB_ROOT}/downloads/reservations2006.zip`}
                      aria-label="RIDB/Recreation.gov Historical Reservation Data Fiscal Year 2006">
                      FY 2006
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${process.env.RIDB_ROOT}/downloads/reservations2007.zip`}
                      aria-label="RIDB/Recreation.gov Historical Reservation Data Fiscal Year 2007">
                      FY 2007
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${process.env.RIDB_ROOT}/downloads/reservations2008.zip`}
                      aria-label="RIDB/Recreation.gov Historical Reservation Data Fiscal Year 2008">
                      FY 2008
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${process.env.RIDB_ROOT}/downloads/reservations2009.zip`}
                      aria-label="RIDB/Recreation.gov Historical Reservation Data Fiscal Year 2009">
                      FY 2009
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${process.env.RIDB_ROOT}/downloads/reservations2010.zip`}
                      aria-label="RIDB/Recreation.gov Historical Reservation Data Fiscal Year 2010">
                      FY 2010
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${process.env.RIDB_ROOT}/downloads/reservations2011.zip`}
                      aria-label="RIDB/Recreation.gov Historical Reservation Data Fiscal Year 2011">
                      FY 2011
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${process.env.RIDB_ROOT}/downloads/reservations2012.zip`}
                      aria-label="RIDB/Recreation.gov Historical Reservation Data Fiscal Year 2012">
                      FY 2012
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${process.env.RIDB_ROOT}/downloads/reservations2013.zip`}
                      aria-label="RIDB/Recreation.gov Historical Reservation Data Fiscal Year 2013">
                      FY 2013
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${process.env.RIDB_ROOT}/downloads/reservations2014.zip`}
                      aria-label="RIDB/Recreation.gov Historical Reservation Data Fiscal Year 2014">
                      FY 2014
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${process.env.RIDB_ROOT}/downloads/reservations2015.zip`}
                      aria-label="RIDB/Recreation.gov Historical Reservation Data Fiscal Year 2015">
                      FY 2015
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${process.env.RIDB_ROOT}/downloads/reservations2016.zip`}
                      aria-label="RIDB/Recreation.gov Historical Reservation Data Fiscal Year 2016">
                      FY 2016
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${process.env.RIDB_ROOT}/downloads/reservations2017.zip`}
                      aria-label="RIDB/Recreation.gov Historical Reservation Data Fiscal Year 2017">
                      FY 2017
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${process.env.RIDB_ROOT}/downloads/reservations2018.zip`}
                      aria-label="RIDB/Recreation.gov Historical Reservation Data Fiscal Year 2018">
                      FY 2018
                    </a>
                  </li>
                </ul>
              </div>
              <div className={`body-section ${styles['notice-section']}`}>
                <p><strong>Notice:</strong></p>
                <ul>
                  <li><strong>Please DO NOT share these links as the contain your personal API Key</strong></li>
                  <li>Data sets may be large</li>
                  <li>For more information on how to use the RIDB data, please visit our&nbsp;
                    <Link to="/docs">API Documentation</Link>
                  </li>
                  <li>
                    <strong>
                      By downloading this data, you are agreeing to the&nbsp;
                      <Link to="/ridb-access-agreement">
                        RIDB API Access Agreement.
                      </Link>
                    </strong>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </main>
      </SkipNavContent>
    );
  }
}

DownloadPage.propTypes = propTypes;

const mapStateToProps = (state) => ({
  currentUser: getCurrentUser(state)
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  addAlert
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DownloadPage);
